// // import React, { useEffect } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import axios from "axios";

// // function ScanRedirect() {
// //   const location = useLocation();
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     const params = new URLSearchParams(location.search);
// //     const qrShopId = params.get("sID");

// //     if (qrShopId) {
// //       const userLoggedIn = localStorage.getItem("cID"); // customer id
// //       if (userLoggedIn) {
// //         // ✅ save preferred (most recent first, max 5)
// //         let stored = JSON.parse(localStorage.getItem("preferredShops")) || [];
// //         stored = [qrShopId, ...stored.filter((id) => id !== qrShopId)].slice(0, 5);
// //         localStorage.setItem("preferredShops", JSON.stringify(stored));

// //         // ✅ optional backend save
// //         axios
// //           .post("https://sakhisshop.com/api/savePreferred", {
// //             customerId: userLoggedIn,
// //             shopId: qrShopId,
// //           })
// //           .catch((err) => console.error("Preferred save failed:", err));

// //         // ✅ go to dashboard
// //         navigate(`/customer-dashboard?shopId=${qrShopId}`);
// //       } else {
// //         // ✅ not registered → go to registration
// //         navigate(`/CustomerProfileRegistration?shopId=${qrShopId}`);
// //       }
// //     }
// //   }, [location, navigate]);

// //   return <p>Redirecting...</p>; // loader or spinner dikhana
// // }

// // export default ScanRedirect;

// current usese Code : for sometime chagre like

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

function ScanRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  const [preferredShops, setPreferredShops] = useState([]);
  const [shops, setShops] = useState([]);

  // --- Load preferred shops from localStorage on mount ---
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("preferredShops")) || [];
    setPreferredShops(stored.map(Number));
  }, []);

  // --- Listen for updates via custom event ---
  useEffect(() => {
    const handler = (e) => {
      const allShops = JSON.parse(localStorage.getItem("allShops")) || [];
      const updated = e.detail
        .map(Number)
        .filter((id) => allShops.some((s) => s.sID === id));
      setPreferredShops(updated.slice(0, 5));
    };

    window.addEventListener("preferredShopsUpdated", handler);
    return () => window.removeEventListener("preferredShopsUpdated", handler);
  }, []);

  // --- Update preferred shops locally and dispatch event ---
  const updatePreferredLocal = (shopId) => {
    const shopIdNum = Number(shopId);
    let stored = JSON.parse(localStorage.getItem("preferredShops")) || [];
    stored = [shopIdNum, ...stored.filter((id) => id !== shopIdNum)].slice(
      0,
      5,
    );
    localStorage.setItem("preferredShops", JSON.stringify(stored));

    // Notify components to re-render dropdown
    window.dispatchEvent(
      new CustomEvent("preferredShopsUpdated", { detail: stored }),
    );
  };

  // handle scan QR logic
  // const handleQRScan = async (shopId) => {
  //   const cID = localStorage.getItem("cID");

  //   // 🔴 not logged in
  //   if (!cID) {
  //     navigate(`/CustomerProfileRegistration?shopId=${shopId}`);
  //     return;
  //   }

  //   try {
  //     // customer exists?
  //     await axios.get(`https://sakhisshop.com/api/customers/${cID}`);

  //     // join shop
  //     await axios.post(
  //       `https://sakhisshop.com/api/customers/${cID}/join-shop/${shopId}`
  //     );

  //     // preferred
  //     await axios.post(
  //       `https://sakhisshop.com/api/customers/${cID}/preferredShops/${shopId}`
  //     );

  //     navigate(`/customer-dashboard?shopId=${shopId}`);
  //   } catch (err) {
  //     console.warn("Customer invalid, redirecting to register");
  //     localStorage.removeItem("cID");
  //     navigate(`/CustomerProfileRegistration?shopId=${shopId}`);
  //   }
  // };

  // const handleQRScan = async (scannedShopId) => {
  //   console.log("Joining shopId:", scannedShopId, typeof scannedShopId);

  //   // ❌ invalid shopId
  //   if (!scannedShopId || scannedShopId === "undefined") {
  //     console.error("Invalid scannedShopId:", scannedShopId);
  //     return;
  //   }

  //   const cID = localStorage.getItem("cID");

  //   // ❌ no customerId at all → new user
  //   if (!cID) {
  //     navigate(`/CustomerProfileRegistration?shopId=${scannedShopId}`);
  //     return;
  //   }

  //   try {
  //     // 🔥 STEP 0: backend se confirm karo customer exists ya nahi
  //     await axios.get(
  //       `https://sakhisshop.com/api/customers/${cID}`
  //     );

  //     // ✅ customer exists → JOIN SHOP
  //     await axios.post(
  //       `https://sakhisshop.com/api/customers/${cID}/join-shop/${scannedShopId}`
  //     );

  //     await axios.post(
  //       `https://sakhisshop.com/api/customers/${cID}/preferredShops/${scannedShopId}`
  //     );

  //     // 🔁 refresh shops
  //     const res = await axios.get(
  //       `https://sakhisshop.com/api/customers/${cID}/shops`
  //     );
  //     setShops(res.data);

  //     setSelectedShop(String(scannedShopId));

  //     // ✅ dashboard
  //     navigate(`/customer-dashboard?shopId=${scannedShopId}`);

  //   } catch (err) {
  //     // ❌ customer backend me nahi mila → registration
  //     console.warn("Customer not found, redirecting to register");

  //     localStorage.removeItem("cID"); // 🔒 safety cleanup
  //     navigate(`/CustomerProfileRegistration?shopId=${scannedShopId}`);
  //   }
  // };

  // QR Scan
  //  ├─ User NOT logged in → Registration → Login → Dashboard (shop auto-joined)

  //  └─ User logged in     → Join shop → Dashboard (NO registration)

  const handleQRScan = async (shopId) => {
    if (!shopId || isNaN(shopId)) return;

    // ✅ ONLY ONE SOURCE OF TRUTH
    const customerId = localStorage.getItem("customerId");

    // ❌ user logged in hi nahi
    if (!customerId) {
      navigate(`/CustomerProfileRegistration?shopId=${shopId}`);
      return;
    }

    try {
      // ✅ join shop (idempotent)
      await axios.post(
        `https://sakhisshop.com/api/customers/${customerId}/join-shop/${shopId}`,
      );

      // ✅ preferred shop
      await axios.post(
        `https://sakhisshop.com/api/customers/${customerId}/preferredShops/${shopId}`,
      );

      // ✅ dashboard ONLY
      navigate(`/customer-dashboard?shopId=${shopId}`);
    } catch (err) {
      console.error("Shop join failed:", err);

      // ❌ registration pe wapas kabhi mat bhejo
      navigate(`/customer-dashboard`);
    }
  };

  //////................

  // const handleQRScan = (scannedShopId) => {
  //   const userLoggedIn = localStorage.getItem("cID");
  //   if (userLoggedIn) {
  //     updatePreferredLocal(scannedShopId); // local update + event dispatch

  //     // backend sync
  //     axios
  //       .post(
  //         `https://sakhisshop.com/api/customers/${userLoggedIn}/preferredShops/${scannedShopId}`
  //       )
  //       .catch((err) => console.error("Backend preferred save failed:", err));

  //     // navigate dashboard
  //     navigate(`/customer-dashboard?shopId=${scannedShopId}`);
  //   } else {
  //     // Not registered → registration page
  //     navigate(`/CustomerProfileRegistration?shopId=${scannedShopId}`);
  //   }
  // };

  // --- QR scan from URL (desktop / direct link) ---
  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const qrShopId = params.get("sID");

  //   if (qrShopId) handleQRScan(qrShopId);
  // }, [location]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const qrShopId = params.get("sID");

    if (!qrShopId) return;

    const shopIdNum = Number(qrShopId);
    if (isNaN(shopIdNum)) {
      console.error("Invalid shopId from QR:", qrShopId);
      return;
    }

    handleQRScan(shopIdNum);
  }, [location.search]);

  // --- QR scan callback (mobile scanner) ---
  // Example: if using react-qr-reader in mobile scanner component:
  // <QrReader
  //    delay={300}
  //    onError={(err) => console.error(err)}
  //    onScan={(data) => { if (data) handleQRScan(data); }}
  //    style={{ width: '100%' }}
  // />

  return null; // only redirect & update
}

export default ScanRedirect;

// pura code update hai issue ke thrugh:
// import { useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";

// function ScanRedirect() {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const handleQRScan = async (scannedShopId) => {
//   console.log("Joining shopId:", scannedShopId, typeof scannedShopId);

//   // ❌ invalid shopId
//   if (!scannedShopId || scannedShopId === "undefined") {
//     console.error("Invalid scannedShopId:", scannedShopId);
//     return;
//   }

//   const cID = localStorage.getItem("cID");

//   // ❌ no customerId at all → new user
//   if (!cID) {
//     navigate(`/CustomerProfileRegistration?shopId=${scannedShopId}`);
//     return;
//   }

//   try {
//     // 🔥 STEP 0: backend se confirm karo customer exists ya nahi
//     await axios.get(
//       `https://sakhisshop.com/api/customers/${cID}`
//     );

//     // ✅ customer exists → JOIN SHOP
//     await axios.post(
//       `https://sakhisshop.com/api/customers/${cID}/join-shop/${scannedShopId}`
//     );

//     await axios.post(
//       `https://sakhisshop.com/api/customers/${cID}/preferredShops/${scannedShopId}`
//     );

//     // 🔁 refresh shops
//     const res = await axios.get(
//       `https://sakhisshop.com/api/customers/${cID}/shops`
//     );
//     setShops(res.data);

//     setSelectedShop(String(scannedShopId));

//     // ✅ dashboard
//     navigate(`/customer-dashboard?shopId=${scannedShopId}`);

//   } catch (err) {
//     // ❌ customer backend me nahi mila → registration
//     console.warn("Customer not found, redirecting to register");

//     localStorage.removeItem("cID"); // 🔒 safety cleanup
//     navigate(`/CustomerProfileRegistration?shopId=${scannedShopId}`);
//   }
// };
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const qrShopId = params.get("sID");

//     if (!qrShopId) return;

//     const shopIdNum = Number(qrShopId);
//     if (isNaN(shopIdNum)) return;

//     handleQRScan(shopIdNum);
//   }, [location.search]);

//   return null;
// }

// export default ScanRedirect;
